/**
 * Supported Routes.
 */
export enum Routes {
    OVERVIEW = '/',
    RECOMMENDED = '/recommended',
    CONTACTED = '/contacted',
    ACTIVE_CONVERSATIONS = '/active-conversations',
    LISTED = '/listed',
    SOLD = '/sold',
    ARCHIVE = '/archived',
    PROPERTY = '/property/:propertyId',
    SEARCH = '/search',
    SIGN_IN = '/sign-in',
    SIGN_UP = '/sign-up',
    MAIN_SITE_SIGN_UP = 'https://www.catalyzeai.com/real-estate/main',
    SIGN_UP_APPROVAL = '/sign-up-approval',
    CREATE_PASSWORD = '/sign-up-finish/:emailToken',
    CHANGE_PASSWORD = '/change-password/:emailToken',
    PROFILE = '/profile',
    SUBSCRIBE = '/subscribe',
    SUBSCRIBED = '/subscribed',
    SUBSCRIBED_V2 = '/subscribed-v2',
    SUBSCRIPTION = '/subscription',
    NOT_FOUND = '*',
    RESET_PASSWORD = '/reset-password',
    ZIP_CHECK = '/zip-check',
}

/**
 * A helper mapping used for getting real Routes ENUM from the route string.
 */
export const ReverseMappedRoutes: Record<string, Routes> = {
    [Routes.OVERVIEW]: Routes.OVERVIEW,
    [Routes.RECOMMENDED]: Routes.RECOMMENDED,
    [Routes.CONTACTED]: Routes.CONTACTED,
    [Routes.ACTIVE_CONVERSATIONS]: Routes.ACTIVE_CONVERSATIONS,
    [Routes.LISTED]: Routes.LISTED,
    [Routes.SOLD]: Routes.SOLD,
    [Routes.ARCHIVE]: Routes.ARCHIVE,
    [Routes.SEARCH]: Routes.SEARCH,
    [Routes.PROFILE]: Routes.PROFILE,
    [Routes.NOT_FOUND]: Routes.NOT_FOUND,
};
